<template>
	<div class="pt-22 plr-16 box-s">
    <div class="fz-14 fw-500 c1 mb-18">
      每日一练
		</div>

		<ul class="flex flex-wrap">
			<li v-for="(item, index) in list" :key="index" class="wh_36 mb-10 text-center l-h-36 b-radius-50 bb_fo mr-15" :class="{ 'active':item.answer && item.answer.length != 0 }" @click="getQuest(item, index)">{{index + 1}}</li>

		</ul>

		<div class="btn_contain">
      <div class="blue_btn" @click="submit">
        提交
      </div>
    </div>
	</div>
</template>
<script>
	import { submitQuestion } from '@/api/api.js'
	export default {
		components: {
		},
		data() {
			return {
       list: [],
			 num: 0
			};
		},
		created() {
			this.list = JSON.parse(this.$route.query.form)
			this.list.forEach(item => {
        if(!item.answer.length){
					this.num = this.num + 1
				}
			})
		},
		methods: {
      submit(){
				if(this.num){

          this.$dialog.confirm({
						title: '提示',
						message:
							`还有${this.num}道题未作答，是否提交答案？`,
					})
						.then(() => {
							this.getSubmit()
						})
						.catch(() => {
							// on cancel
						});
				} else {
					this.getSubmit()
				}
				
				
			},
			async getSubmit(){
        const res = await submitQuestion({answer: this.$route.query.form, dailyStudyId: this.$route.query.dailyStudyId })
				if( res.code == 1000 ){
					this.$toast.success('答题完成')
          setTimeout(()=>{
						this.$router.replace({ path: '/report', query: { dailyStudyId: this.$route.query.dailyStudyId } })
					}, 1000)
				} else {
            this.$toast(res.msg)
          }
			},
			getQuest(item, index){
				this.$router.replace({ path: '/startpractice', query: { id: this.$route.query.id, form: this.$route.query.form, qusetNum: (index + 1) } })
			}
    }
	};
</script>
<style lang="less" scoped>
.active {
	border: 1px solid #497CFF;
	color: #497CFF;
}
</style>
